export const highlight = {
    updated(el, binding) {
        const search = binding.value;
        const text = el.textContent;

        if (!text || !search) {
            return text;
        }

        el.innerHTML = text.replace(new RegExp(search, "gi"), (match) => {
            return '<span class="searchKeyword">' + match + "</span>";
        });
    },
};
